import React, { useEffect, useState } from "react";
import scheduleService from "../../services/schedule.service";
import Loadding from "../common/loadding";
import BtnEditSche from "./btnEditSche";

const TableClose = (props: any) => {
  const [openList, setOpenList] = useState([]);
  const { keyFind } = props;
  const [status, setStatus] = useState(true);

  useEffect(() => {
    (async () => {
      //ส่งไปค้นตรงนี้
      scheduleService.getScheduleClose().then((res) => {
        setOpenList(
          res.data.filter(
            (item: any) =>
              item.type.includes(keyFind) ||
              item.year.toString().includes(keyFind)
          )
        );
        setStatus(false);
      });
    })();
  }, [keyFind]);
  if (status) {
    return <Loadding />;
  }

  return (
    <>
      <table className="table table-hover table-responsive">
        <thead className="table-dark">
          <tr>
            <th>ปีการศึกษา {keyFind}</th>
            <th>ภาคการศึกษา</th>
            <th>ประเภทเอกสาร</th>
            <th>Handle</th>
          </tr>
        </thead>
        <tbody>
          {!(openList.length > 0) && (
            <tr>
              <td colSpan={4} className="text-danger">
                <i className="bi bi-folder-x"></i> ไม่พบข้อมูล
              </td>
            </tr>
          )}
          {/* ///////////////////////////////////////////////////////////////////////////////////////// */}
          {openList.length > 0 &&
            openList.map((schedule: any) => {
              return (
                <tr key={schedule.id}>
                  <td>{schedule.year}</td>
                  <td>{schedule.term}</td>
                  <td>{schedule.type === "mhesi" ? "อชว." : "มคอ."} | RMUTI</td>
                  <td>
                    <BtnEditSche id={schedule.id} sche={schedule} />{" "}
                  </td>
                </tr>
              );
            })}

          {/* ///////////////////////////////////////////////////////////////////////////////////////// */}
        </tbody>
      </table>
    </>
  );
};

export default TableClose;
